export default __webpack_public_path__ + "018cc4d4929466938b40ed046633e943.svg";